import { Doc } from '@dadohr/shared/domainTypes/document';
import { FS } from '@dadohr/shared/versions';
import { store, updateDocFromPartial } from '../firebase';
import {
  CollectionListener,
  createCollectionListenerStore,
  createSingleCollectionListenerStore,
  useCollectionListener
} from '../firecache/collectionListener';
import {
  createDocumentListenerGetter,
  useDocumentListener
} from '../firecache/documentListener';
import { toAiUsageCurrentDoc, toAiUsageHistoryDoc } from './documents';

// Collection references
const aiUsageCurrentCollection = () => store().collection(FS.aiUsageCurrent);
const aiUsageHistoryCollection = () => store().collection(FS.aiUsageHistory);

// Document listener for current usage (by org ID - document ID is the org ID)
export const aiUsageCurrentStore = createDocumentListenerGetter(
  (orgId) => aiUsageCurrentCollection().doc(orgId),
  toAiUsageCurrentDoc
);

// Get current usage for an org
export const getAiUsageCurrent = (orgId: string) => {
  return aiUsageCurrentStore(orgId).get();
};

// Hook for current usage
export const useAiUsageCurrentByOrgId = (orgId: string) => {
  return useDocumentListener(aiUsageCurrentStore(orgId));
};

// Collection listener for all current usage (for admin overview)
const allAiUsageCurrentStore = createSingleCollectionListenerStore(
  () => new CollectionListener(aiUsageCurrentCollection(), toAiUsageCurrentDoc)
);

// Hook for all current usage
export const useAllAiUsageCurrent = () => {
  return useCollectionListener(allAiUsageCurrentStore());
};

// Collection listener for usage history by org
const aiUsageHistoryByOrgStore = createCollectionListenerStore(
  (orgId) =>
    new CollectionListener(
      aiUsageHistoryCollection()
        .where('organizationId', '==', orgId)
        .orderBy('periodStart', 'desc'),
      toAiUsageHistoryDoc
    )
);

// Hook for usage history
export const useAiUsageHistoryByOrgId = (orgId: string) => {
  return useCollectionListener(aiUsageHistoryByOrgStore(orgId));
};

// Update limits for an org's current usage
// Note: Pass null to clear a limit, pass a number to set it
export const updateAiUsageLimits = async (
  orgId: string,
  limits: { tokenLimit: number | null; requestLimit: number | null }
) => {
  const doc: Doc<{ tokenLimit: number | null; requestLimit: number | null }> = {
    id: orgId,
    collection: FS.aiUsageCurrent,
    data: {
      tokenLimit: limits.tokenLimit,
      requestLimit: limits.requestLimit
    }
  };
  await updateDocFromPartial(doc);
};
